import React, { useEffect, useState } from 'react'
import ReportHeader from '../../../../common/ReportHeader'
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableRow } from '@mui/material'
import jsPDF from 'jspdf'
import { callAddFontRobotoBold } from '../../../../../assets/fonts/Roboto-bold'
import { callAddFontRobotoNormal } from '../../../../../assets/fonts/Roboto-normal'
import { calculateDynamicFormatLandscape, calculateDynamicFormatPortrait, calculateTotalTableWidth } from '../../AccountsReports/PreponePostpone/Constants'
import { TableHeaderColumn } from './Constants'
import autoTable from 'jspdf-autotable'
import { onlineReportMenu, reportMenu } from '../../../../../redux/Actions'
import { useDispatch, useSelector } from 'react-redux'
import { focusElemnt, navigation3 } from '../../../../../utilityFunctions'
import moment from 'moment'
import { getTotalByKey } from '../../../../generics/helper'
const CancelTransactionSummaryTable = ({ reportTableData, handleBack }) => {
    const dispatch = useDispatch()
    const user = useSelector((store) => store.user);
    const { header, TableData } = reportTableData || {};
    const currentDateTime = moment(window.getTime ? window.getTime() : new Date()).format('DD-MMM-YYYY HH:mm');
    const [tableData, setTableData] = useState([])

    useEffect(() => {
        setTimeout(() => {
            focusElemnt('backBTN')
        }, 100)
    }, [])

    useEffect(() => {
        if (TableData?.length > 0) {
            const updatedData = groupData(TableData)
            setTableData(updatedData)
        } else {
            setTableData([])
        }
    }, [TableData])

    const groupData = (array) => {
        let newData = []
        let totalarray = []
        let groupedData = array.reduce((result, item) => {
            const key = item.PGName === 'RAZORPAY' ? 'Kotak - Razorpay' : `Kotak - Easebuzz`
            if (!result[key]) {
                result[key] = []
            } result[key].push(item)
            return result
        }, {})
        Object.keys(groupedData).forEach((key) => {
            let updatedData = [...groupedData[key]]
            const keys = ["TxnCount", "Amount", "RefundedCount", "RefundedAmount", "RefundedPtc", "PendingCount", "PendingAmount", "PendingPtc"];
            let totals = getTotalByKey(groupedData[key], keys);
            totals = {
                ...totals,
                Amount: Math.round(Number(totals?.Amount)),
                RefundedAmount: Math.round(Number(totals?.RefundedAmount)),
                PendingAmount: Math.round(Number(totals?.PendingAmount)),
                RefundedPtc: Math.round((totals.RefundedCount * 100) / totals.TxnCount),
                PendingPtc: Math.round((totals.PendingCount * 100) / totals.TxnCount),
            }
            totals.TxnDate = "Total"
            totals.isTotal = true
            totalarray.push(totals)
            updatedData.push(totals)
            updatedData.unshift({ isHeaderRow: true, TxnDate: 'Date', TxnCount: 'Txn', Amount: 'Amount', RefundedCount: 'Txn', RefundedAmount: 'Amount', RefundedPtc: '%', PendingCount: 'Txn', PendingAmount: 'Amount', PendingPtc: '%' },)
            updatedData.unshift({ TxnCount: "Total Cancelled", RefundedCount: "Total Refund", PendingCount: "Pending Refund", isSubHeading: true })
            updatedData.unshift({ TxnDate: key, isHeading: true })
            newData = [...newData, ...updatedData]
        })
        const keys = ["TxnCount", "Amount", "RefundedCount", "RefundedAmount", "RefundedPtc", "PendingCount", "PendingAmount", "PendingPtc"];
        let allTotal = getTotalByKey(totalarray, keys);
        allTotal = {
            ...allTotal,
            Amount: Math.round(Number(allTotal?.Amount)),
            RefundedAmount: Math.round(Number(allTotal?.RefundedAmount)),
            PendingAmount: Math.round(Number(allTotal?.PendingAmount)),
            RefundedPtc: Math.round((allTotal.RefundedCount * 100) / allTotal.TxnCount),
            PendingPtc: Math.round((allTotal.PendingCount * 100) / allTotal.TxnCount),
        }
        allTotal.TxnDate = "Grand Total"
        allTotal.isTotal = true
        newData.push(allTotal)
        return newData
    }

    const InsideRowContent = ({ item, index, fontVal }) => {
        return (
            <>
                {
                    item.isHeading ? (
                        <>
                            <TableRow key={index}>
                                <>
                                    <TableCell
                                        className="reportTD"
                                        colSpan={9}
                                        style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'left' }}
                                    >
                                        {item.TxnDate}
                                    </TableCell>
                                </>
                            </TableRow>
                        </>
                    ) : item.isSubHeading ? (
                        <TableRow key={index}>
                            <>
                                <TableCell
                                    className="reportTD"
                                    colSpan={3}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'center', borderRight: '1px solid #e0e0e0' }}
                                >
                                    {item.TxnCount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={3}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'center', borderRight: '1px solid #e0e0e0' }}
                                >
                                    {item.RefundedCount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={3}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'center' }}
                                >
                                    {item.PendingCount}
                                </TableCell>
                            </>
                        </TableRow>
                    ) : item.isHeaderRow ? (
                        <TableRow>
                            <>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', color: '#000000', textAlign: 'left' }}
                                >
                                    {item.TxnDate}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', color: '#000000', textAlign: 'right' }}
                                >
                                    {item.TxnCount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', color: '#000000', textAlign: 'right', borderRight: '1px solid #e0e0e0' }}
                                >
                                    {item.Amount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', color: '#000000', textAlign: 'right' }}
                                >
                                    {item.RefundedCount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', color: '#000000', textAlign: 'right' }}
                                >
                                    {item.RefundedAmount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', color: '#000000', textAlign: 'right', borderRight: '1px solid #e0e0e0' }}
                                >
                                    {item.RefundedPtc}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', color: '#000000', textAlign: 'right' }}
                                >
                                    {item.PendingCount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', color: '#000000', textAlign: 'right' }}
                                >
                                    {item.PendingAmount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', color: '#000000', textAlign: 'right' }}
                                >
                                    {item.PendingPtc}
                                </TableCell>
                            </>
                        </TableRow>
                    ) : item.isTotal ? (
                        <>
                            <TableRow key={index}>
                                <>
                                    <TableCell
                                        className="reportTD"
                                        colSpan={1}
                                        style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'left' }}
                                    >
                                        {item.TxnDate}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        colSpan={1}
                                        style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                                    >
                                        {item.TxnCount}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        colSpan={1}
                                        style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'right', borderRight: '1px solid #e0e0e0' }}
                                    >
                                        {item.Amount}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        colSpan={1}
                                        style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                                    >
                                        {item.RefundedCount}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        colSpan={1}
                                        style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                                    >
                                        {item.RefundedAmount}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        colSpan={1}
                                        style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'right', borderRight: '1px solid #e0e0e0' }}
                                    >
                                        {item.RefundedPtc}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        colSpan={1}
                                        style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                                    >
                                        {item.PendingCount}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        colSpan={1}
                                        style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                                    >
                                        {item.PendingAmount}
                                    </TableCell>
                                    <TableCell
                                        className="reportTD"
                                        colSpan={1}
                                        style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '700', textAlign: 'right' }}
                                    >
                                        {item.PendingPtc}
                                    </TableCell>
                                </>
                            </TableRow>
                        </>
                    ) : (
                        <TableRow>
                            <>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'left' }}
                                >
                                    {item.TxnDate}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                                >
                                    {item.TxnCount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right', borderRight: '1px solid #e0e0e0' }}
                                >
                                    {item.Amount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right', }}
                                >
                                    {item.RefundedCount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                                >
                                    {item.RefundedAmount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right', borderRight: '1px solid #e0e0e0' }}
                                >
                                    {item.RefundedPtc}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                                >
                                    {item.PendingCount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                                >
                                    {item.PendingAmount}
                                </TableCell>
                                <TableCell
                                    className="reportTD"
                                    colSpan={1}
                                    style={{ background: 'F5FAFE', fontSize: fontVal, fontWeight: '500', textAlign: 'right' }}
                                >
                                    {item.PendingPtc}
                                </TableCell>

                            </>
                        </TableRow>
                    )
                }
            </>
        )
    }
    const generatepdf = (isSave) => {
        jsPDF.API.events.push(['addFonts', callAddFontRobotoBold])
        jsPDF.API.events.push(["addFonts", callAddFontRobotoNormal]);

        const pdfColumns = TableHeaderColumn.map((col) => {
            return { header: col.headerName, dataKey: col.field, xlCol: col.xlCol, headerSx: col.headerSx }
        })
        const widthCell = calculateTotalTableWidth(TableHeaderColumn)
        // const doc = new jsPDF({ orientation: 'l', format: [1080, 1528], unit: 'px', compress: true })
        const doc = new jsPDF({ orientation: pdfColumns.length > 12 ? 'l' : 'p', format: pdfColumns.length > 12 ? calculateDynamicFormatLandscape((widthCell > 1122 ? widthCell : 1122) + 60) : calculateDynamicFormatPortrait((widthCell > 793 ? widthCell : 793) + 60), unit: 'px', compress: true })
        // var pageSize = doc.internal.pageSize
        doc.autoTableSetDefaults({
            headStyles: { fontSize: 6, width: 'auto', halign: 'right', fillColor: [30, 89, 167] },
        })
        var totalPagesExp = '{total_pages_count_string}'
        doc.setProperties({
            title: `Online Report.pdf`,
            subject: 'Report',
            author: 'Karnataka State Road Transport Corporation',
            keywords: 'Mantis Technologies Private Limited',
            creator: 'KSRTC',
        })
        autoTable(doc, {
            margin: { top: 180, left: 30, right: 30, bottom: 40 },
            alternateRowStyles: {
                fillColor: [255, 255, 255],
            },
            columns: pdfColumns,
            body: tableData,
            columnStyles: {
                0: { halign: 'left', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                1: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                2: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                3: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                4: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                5: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                6: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                7: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
                8: { halign: 'right', fontSize: 14, minCellHeight: 36, cellPadding: 6, valign: 'middle', minCellWidth: 37, font: 'Roboto', textColor: [0, 0, 0], fontStyle: 'normal' },
            },
            showHead: 'never',
            theme: 'grid',
            styles: {
                lineWidth: [0, 0.2, 0, 0.6],
            },
            tableLineWidth: 0.6,
            headStyles: {
                fontSize: 16,
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                cellPadding: 6,
                valign: 'middle',
                fontStyle: 'normal',
                font: 'Roboto',

            },
            didParseCell: (data) => {
                // drawCell(data)
                if (data.row.section === 'head') {
                    if (['number', 'quantity', 'currency'].indexOf(data.column.raw.xlCol.dataType) !== -1) {
                        data.cell.styles.halign = 'right'
                    } else {
                        data.cell.styles.halign = 'left'
                    }
                }
            },
            didDrawPage: function (data) {
                var doc = data.doc;
                doc.setTextColor('#000000');

                // Calculate text width and center for the first text
                var text1 = 'KARNATAKA STATE ROAD TRANSPORT CORPORATION';
                var textWidth1 = doc.getStringUnitWidth(text1) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                var centerX1 = (doc.internal.pageSize.width - textWidth1) / 2;

                // Set font size and style for the first text
                doc.setFontSize(18).setFont("Roboto", 'normal', '700');
                doc.setTextColor('#000000');
                // Draw the first text at the calculated x-coordinate
                doc.text(text1, centerX1, 60);

                // Set font size, weight, and color for the second text
                doc.setFontSize(14).setFont("Roboto", 'normal', '600');
                doc.setTextColor('#000000');
                // Calculate text width and center for the second text
                var text2 = 'CANCELLED TRANSACTION SUMMARY';
                var textWidth2 = doc.getStringUnitWidth(text2) * doc.internal.getFontSize() / doc.internal.scaleFactor;
                var centerX2 = (doc.internal.pageSize.width - textWidth2) / 2;
                // Draw the second text at the calculated x-coordinate below the first text
                doc.text(text2, centerX2, 80); // Adjust the vertical position as needed
                doc.setTextColor(0, 0, 0)
                doc.setFontSize(18)
                doc.setFont('Roboto', '')
                doc.text(`From Date:${moment(header?.fromDate).format("DD-MMM-YYYY")} -To Date:${moment(header?.toDate).format("DD-MMM-YYYY")}`, 30, 170)
                // doc.setFontSize(18)
                // doc.setFont('Roboto', '')
                // doc.text(`From Date : Mtmm /21/Feb/2024/15:45:00`, 30, 145)
                doc.setFontSize(18)
                doc.setFont('Roboto', '')
                doc.text(`User : ${user?.UserName || ''} (${sessionStorage.getItem('LoginId') || ""})`, doc.internal.pageSize.width - data.settings.margin.left, 145, 'right')
                doc.text(`Print Date & Time : ${currentDateTime}`, doc.internal.pageSize.width - data.settings.margin.left, 170, 'right')
            },
        })
        doc.setFont('Roboto')

        if (typeof doc.putTotalPages === 'function') {
            doc.putTotalPages(totalPagesExp)
        }
        if (isSave) {
            doc.save(`CANCELLED TRANSACTION SUMMARY ${new Date().getTime()}.pdf`)
        } else {
            const newTab = window.open();
            newTab.document.write('<iframe width="100%" height="100%" src="' + doc.output('datauristring', 'CANCELLED TRANSACTION SUMMARY') + '"></iframe>');
        }
    }
    return (
        <>
            <ReportHeader mainHeaderName='Report' headerName='Online Report' openSubMenu={() => dispatch(reportMenu(true))} subHeader={'CANCELLED TRANSACTION SUMMARY'} subHeaderVisible={() => dispatch(onlineReportMenu(true))} mainMenuOpen={true} />
            <Box sx={{ display: 'flex', flexDirection: 'row', padding: '16px 0px 16px 0px', justifyContent: 'center', alignItems: 'center', gap: '10px', height: '76px' }}>
                <div style={{ position: 'relative' }}>
                    <Button
                        startIcon={<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <g mask="url(#mask0_781_30893)">
                                <path d="M18 7H6V3H18V7ZM18 12.5C18.2833 12.5 18.5208 12.4042 18.7125 12.2125C18.9042 12.0208 19 11.7833 19 11.5C19 11.2167 18.9042 10.9792 18.7125 10.7875C18.5208 10.5958 18.2833 10.5 18 10.5C17.7167 10.5 17.4792 10.5958 17.2875 10.7875C17.0958 10.9792 17 11.2167 17 11.5C17 11.7833 17.0958 12.0208 17.2875 12.2125C17.4792 12.4042 17.7167 12.5 18 12.5ZM16 19V15H8V19H16ZM18 21H6V17H2V11C2 10.15 2.29167 9.4375 2.875 8.8625C3.45833 8.2875 4.16667 8 5 8H19C19.85 8 20.5625 8.2875 21.1375 8.8625C21.7125 9.4375 22 10.15 22 11V17H18V21Z" fill="white" />
                            </g>
                        </svg>
                        }

                        variant="contained"
                        size="medium"
                        id='printBTN'
                        className={`btn-orange`}
                        onClick={() => generatepdf(false)}
                        onKeyDown={(e) => navigation3(e, "exportPdfBTN", "", () => { })}
                    >
                        Print
                    </Button>
                </div>
                <div>
                    <Button
                        startIcon={
                            <svg width="13" height="16" viewBox="0 0 13 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fillRule="evenodd" clipRule="evenodd" d="M10.0361 4.50132C9.17024 4.50132 8.47694 3.80881 8.47694 2.9507V0H1.50769C1.102 0 0.729623 0.150546 0.442012 0.439594C0.151374 0.72563 0 1.09597 0 1.49944V14.5006C0 15.3256 0.678156 16 1.50769 16H11.4923C12.3218 16 13 15.3256 13 14.5006V4.50132H10.0361ZM10.0876 10.7249C9.85142 10.9597 9.52748 11.0952 9.20657 11.0952C8.73125 11.0952 8.17117 10.8242 7.54448 10.3184C7.24407 10.3771 6.91751 10.4641 6.53956 10.5649L6.39101 10.6044C6.07264 10.692 5.78967 10.7905 5.53455 10.8793L5.53454 10.8793L5.40708 10.9236C4.89846 11.8329 4.23847 12.7603 3.60876 12.9138C3.54215 12.9319 3.47252 12.9469 3.40592 12.9469C3.23638 12.9469 3.085 12.8957 2.94877 12.7783C2.72776 12.5916 2.62785 12.3387 2.67629 12.0708C2.81253 11.3782 3.92967 10.7881 4.9469 10.3846C5.07655 10.144 5.18975 9.8869 5.30216 9.63165L5.30217 9.63163L5.31928 9.59277C5.52212 9.08694 5.69166 8.63229 5.80973 8.24388C5.33442 7.36771 4.94388 6.28679 5.21635 5.69665C5.35258 5.41061 5.60689 5.242 5.94597 5.242C6.25175 5.242 6.48789 5.35943 6.64229 5.59729C6.94807 6.03688 6.8966 6.89499 6.52422 8.17764C6.69376 8.46368 6.88146 8.73466 7.051 8.91833C7.28714 9.17125 7.52632 9.4061 7.74732 9.59277C9.10363 9.35792 10.0028 9.45728 10.2722 9.89688L10.2784 9.9139C10.3224 10.033 10.4414 10.3558 10.0876 10.7249ZM12.7688 3.37228H10.038C9.8019 3.37228 9.6142 3.1856 9.61722 2.93569V0.237915C9.72016 0.304155 9.80493 0.373406 9.87153 0.439646L12.566 3.11936C12.6508 3.20367 12.7174 3.28797 12.7688 3.37228ZM5.92061 5.90137C6.02052 5.90137 6.05382 5.93449 6.07199 5.96761C6.19006 6.13622 6.20822 6.55775 6.05685 7.26832C5.82071 6.7113 5.69961 6.1874 5.80254 5.95255C5.80254 5.93449 5.82071 5.90137 5.92061 5.90137ZM6.10893 9.34174C6.15324 9.22081 6.19647 9.10283 6.24025 8.98758L6.29166 9.05331C6.38839 9.17717 6.4738 9.28654 6.54603 9.36093L6.59343 9.41345C6.7103 9.54312 6.81637 9.66079 6.93657 9.76439C6.71557 9.83064 6.46126 9.89989 6.20695 9.96613L6.17812 9.9742L6.17812 9.9742L6.1781 9.97421C6.06901 10.0047 5.95548 10.0365 5.81641 10.0836C5.83047 10.0509 5.84408 10.021 5.85741 9.99168C5.87852 9.94526 5.89893 9.90037 5.91934 9.8487C5.98719 9.67395 6.04904 9.50516 6.10891 9.34177L6.10892 9.34176L6.10893 9.34174ZM3.30469 12.2062C3.35615 12.2905 3.37129 12.2905 3.42276 12.2905C3.6589 12.2243 3.99798 11.8871 4.33706 11.3812C3.66193 11.7184 3.33799 12.0376 3.30469 12.2062ZM9.21996 10.4208C8.99895 10.4208 8.74464 10.3184 8.45703 10.1498C9.27142 10.0655 9.71344 10.1167 9.62564 10.2522C9.54087 10.3877 9.40766 10.4389 9.21996 10.4208Z" fill="white" />
                            </svg>
                        }
                        variant="contained" size="medium"
                        id='exportPdfBTN'
                        className={`btn-orange`}
                        onClick={() => generatepdf(true)}
                        onKeyDown={(e) => navigation3(e, "backBTN", "printBTN", () => { })}
                    >
                        Export As Pdf
                    </Button>
                </div>
                <div>
                    <Button
                        variant="outlined"
                        size="medium"
                        id='backBTN'
                        className={`btn-orange-outline`}
                        onClick={() => handleBack()}
                        onKeyDown={(e) => navigation3(e, "printBTN", "exportPdfBTN", () => { handleBack() })}
                    >
                        Back
                    </Button>
                </div>
            </Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', top: '104px', left: '60', padding: '30px', gap: '16px' }}>
                {/* <CommonReportHeader reportName={'BUS STATION WISE BOOKED e-TICKETS'} reportNameTwo={'Bus Station: All'} headerData={headerData} /> */}
                <Box sx={{ textAlign: 'center' }}>
                    <div className='main_heading'>KARNATAKA STATE ROAD TRANSPORT CORPORATION</div>
                    <div className='sub_heading1'>CANCELLED TRANSACTION SUMMARY</div>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '20px' }}>
                        <div style={{ textAlign: 'left' }}>
                            <span className='sub_heading2' tyle={{ padding: '0px 16px 0px 0px' }}>From Date:{moment(header?.fromDate).format("DD-MMM-YYYY")}-</span>
                            <span className='sub_heading2' tyle={{ padding: '0px 0px 0px 16px' }}>To Date:{moment(header?.toDate).format("DD-MMM-YYYY")}</span>
                        </div>
                        <div style={{ textAlign: 'left' }}>
                            <span className='sub_heading2' tyle={{ padding: '0px 16px 0px 0px' }}>User : </span>
                            <span className='sub_heading2' tyle={{ padding: '0px 0px 0px 16px' }}>{user?.UserName || ''} ({sessionStorage.getItem('LoginId') || ""})</span>
                        </div>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', height: '20px' }}>
                        <div style={{ textAlign: 'left' }}>
                            <span className='sub_heading2' tyle={{ padding: '0px 16px 0px 0px' }}></span>
                            <span className='sub_heading2' tyle={{ padding: '0px 0px 0px 16px' }}></span>
                        </div>
                        <div style={{ textAlign: 'left' }}>
                            <span className='sub_heading2' tyle={{ padding: '0px 16px 0px 0px' }}>Print Date & Time : </span>
                            <span className='sub_heading2' tyle={{ padding: '0px 0px 0px 16px' }}>{currentDateTime}</span>
                        </div>
                    </Box>
                </Box>
                <Box sx={{ padding: '10px 0px 10px 0px' }}>
                    {/* <div style={{ fontSize: '14px', fontWeight: '600', padding: '0px 4px 0px 0px', height: '30px' }}> Booked Ticket Details</div> */}
                    <TableContainer component={Paper} sx={{
                        marginBottom: "30px", border: '1px solid #000000'
                    }} >
                        <Table stickyHeader size="small" aria-label="a dense table"
                            sx={{
                                '& .MuiTableCell-root': {
                                    padding: '6px 8px !important',
                                }
                            }}
                        >
                            {tableData?.length < 1 ? (
                                <>
                                    <TableBody>
                                        <TableRow>
                                            <TableCell colSpan={13}>
                                                <div
                                                    style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        marginTop: '20px',
                                                        marginBottom: '20px',
                                                        color: 'red',
                                                        fontSize: '12px',
                                                        lineheight: '16px',
                                                        letterspacing: '0.24px',
                                                    }}
                                                >
                                                    <span>No results found. Please refine your search parameters and search again.</span>
                                                </div>
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </>
                            ) : tableData?.length >= 1 ? (
                                <TableBody
                                    // className="filter-data-row"
                                    style={{
                                        textAlign: 'center',
                                        fontSize: '12px',
                                        lineheight: '16px',
                                        letterspacing: '0.24px',
                                        fontWeight: '500',
                                        marginLeft: '5px',
                                    }}
                                >
                                    {tableData?.map((item, index) => (
                                        <InsideRowContent item={item} index={index} key={index} fontVal={'12px'} />
                                    ))}
                                </TableBody>
                            ) : (
                                ''
                            )}
                        </Table>
                    </TableContainer>
                </Box>
            </Box>
        </>
    )
}

export default CancelTransactionSummaryTable